import GroupPostListView from "./GroupPostListView";

export default GroupPostListView;